export default "__VITE_ASSET__CCHM0WWe__"